import React from 'react';
import lebenslaufPDF from '../CBreitbach_CV_2023.pdf';
// import { Route, Link } from "react-router-dom";

const About = () => (
    <div className={"cb-page-about"}>

      <div className={"cb-tile cb-tile-left"}>
        <img className={"cb-spaceholder"} src={process.env.PUBLIC_URL + "/img/560x560.png"} alt={"Spacer"}/>
        <h2>Ich mach’s kurz.</h2>
      </div>

      <div className={"cb-tile cb-tile-right"}>
        <img src={process.env.PUBLIC_URL + "/img/cbr_about.jpg"} alt={"Christoph Breitbach Profilphoto"}/>
      </div>

      <div className={"cb-fullwidth"}>

          <p>Nein, ich habe kein Buch in der Schublade. Storytelling? Lieber in 30 Sekunden als auf 300 Seiten. Deshalb
              mache ich Werbung.</p>

          <p>Genauer gesagt: Ich entwickle Kampagnen und Kommunikationskonzepte für alle Medien, Markenstrategien und
              -positionierungen sowie Produkt- und Markennamen. Natürlich in Zusammenarbeit mit meinen Teampartner:innen,
              Project Leads und Auftraggebenden. Und – wo es Sinn macht – mit KI. Ich arbeite, schreibe und präsentiere
              in Deutsch und Englisch.</p>

          <p>Meinen CV sende ich euch gerne auf Anfrage zu. Soll ja hier kein Roman werden.</p>

        <p><b>Agenturen</b></p>
        <p>Jung von Matt, Hamburg | Grabarz & Partner, Hamburg | DDB, Berlin/Düsseldorf/München |  Castenow, Düsseldorf | Thjnk,
          Düsseldorf | BBDO, Düsseldorf | Saatchi & Saatchi, Düsseldorf | LLR, Hamburg | Aimaq Rapp Stolle, Berlin |
          Serviceplan, Hamburg | Grimm Gallun Holtappels, Hamburg | Heimat, Berlin | Philipp & Keuntje, Hamburg |
          G2, Hamburg | Interone, Hamburg | Rheindenken, Köln | +Knauss, Hamburg | Zum Goldenen Hirschen, Köln |
          Santamaria, Hamburg | Havas, Düsseldorf | Grey, Düsseldorf | TBWA, Berlin | McCann, Düsseldorf | Butter,
          Düsseldorf | Scholz & Friends, Hamburg | The Jupiter Drawing Room, Kapstadt u.a.</p>

        <p><b>Kategorien</b></p>
        <p>Automotive | Food & Beverages | Beauty | Retail | Engineering | Insurance | Telecommunications | Media |
          Banking | Pharma | Energy | Airlines | Tobacco | Travel & Tourism | Industry 4.0 | Luxury Goods | Employer
          Branding u.a.</p>

        <p><b>Awards</b></p>
        <p>Art Directors Club | The New York Festivals | Epica | Moebius | International Automotive Advertising Awards
          u.a.</p>

      </div>

    </div>
);


export { About };


// WEBPACK FOOTER //
// ./src/includes/About.jsx